import { queryOptions } from '@tanstack/react-query'
import { apiExchange, apiGet, apiPost, ApiError } from './client'
import { saveBytes } from './inventoree'

/**
 * `settings/Audit::paper` si `::sign`, peste `AuditReportController`.
 *
 * Documentul vine gata randat, ca HTML intreg: e macheta portalului
 * (`paper.php`), aceeasi pe care iese si PDF-ul. Pagina il pune intr-un cadru
 * - nu il rescrie in React - ca ce se vede pe ecran sa fie chiar ce ajunge in
 * dosar.
 */
export type AuditPaper = {
  version: string
  /** `<title>`-ul documentului: tipul si data fotografiei. */
  title: string
  /** Documentul intreg, `<!doctype html>` cu foaia lui in cap. */
  html: string
  run: { ID: number; type_id: number; status: string; signed_at: string | null }
  /** Semnatura mai acopera documentul? null = nesemnat. */
  signed: boolean | null
  /** Dovezile mai sunt cum au fost inghetate? null = rulare dinaintea sigiliului. */
  seal: boolean | null
  maySign: boolean
  findings: number
}

export function auditPaperQuery(id: number) {
  return queryOptions({
    queryKey: ['settings', 'audit', 'paper', id],
    queryFn: () => apiGet<AuditPaper>(`/settings/audit/paper/${id}`),
    staleTime: 60_000,
  })
}

/**
 * `?pdf=1` din portal: acelasi document, randat pe server si dat ca fisier.
 * Cand serverul n-are cu ce sa-l scoata raspunde cu o propozitie, si aia se
 * arata - nu se salveaza un fisier care nu e un PDF.
 */
export async function downloadAuditPdf(id: number): Promise<void> {
  const out = await apiExchange(`/settings/audit/paper/${id}/pdf`, { method: 'GET' })

  if (!out.type.includes('pdf')) {
    let message = 'The PDF could not be produced. The same document is on the screen, and the browser can still print it.'
    try {
      message = (JSON.parse(out.text) as { message?: string }).message ?? message
    } catch {
      /* Raspunsul nu era JSON; ramane propozitia de mai sus. */
    }
    throw new ApiError(out.status || 501, message)
  }

  saveBytes(out.bytes, out.type, out.filename, `IT-Audit-${id}.pdf`)
}

export type SignAnswer = { ok: true } | { ok: false; error: string }

/** `Audit::sign` - semnatura auditorului-sef pe o fotografie terminata. Un `ok: false` e un refuz spus. */
export function signRun(id: number): Promise<SignAnswer> {
  return apiPost<SignAnswer>(`/settings/audit/sign/${id}`, {})
}
